function inArray(needle, haystack) {
    var length = haystack.length;
    for(var i = 0; i < length; i++) {
        if(haystack[i] == needle) return true;
    }
    return false;
}

jQuery(document).ready(function($){
  
  
  $(".otw-inline-search .js_productSearchResults").hide();
  
  $("body").on("click", function(e){
    if(!$(e.target).parents("li").hasClass("otw-inline-search")){
      $(".otw-inline-search .js_productSearchResults").hide();
    }
  });
  
  $("body").on("focus", ".otw-search-input", function(e){    
      $(".otw-inline-search .js_productSearchResults").show();
  });
  
  
  $(".otw_contact_us_popup").fancybox({'padding': 0});
  
  $(".js_prod_main .slick-slide img").fancybox();
  
  $("body").on("click", ".otw-inline-search-submit-form", function(e){
    let search_input_object = $(this).parents("form").find("input[name='q']");
    search_input_object_value = search_input_object.val();
    search_input_object_value = search_input_object_value.replaceAll("*","").trim();
    search_input_object.val("*"+search_input_object_value.trim()+"*");
    $(this).parents("form").submit();
	e.preventDefault();
	e.stopPropagation();
  });
  
  $("body").on("keyup", ".otw-inline-search input[name='q']", function(e){
    if (e.key === 'Enter' || e.keyCode === 13) {
      search_input_object_value = $(this).val();
      search_input_object_value = search_input_object_value.replaceAll("*","").trim();
      $(this).val('*'+search_input_object_value+'*');
      e.preventDefault();e.stopPropagation();
      $(this).parents("form").submit();
    }
  });

  $(".filter_sidebar_general .list-size .cat-item").each(function(){
    var tags_array = ['xs','s','m','l','xl','xxl','xxxl', 'xxxxl'];
    var tags_object = {xs:"x-small",s:"small",m:"medium",l:"large",xl:"x-large",xxl:"xx-large",xxxl:"xxx-large", xxxxl:"xxxx-large"};
    tag_name = $(this).data('tag-name');
    if(inArray(tag_name, tags_array)){
      //input_value = $(this).find("input").val();
      
      //$(this).find("input").val(tags_object[tag_name]);
      //$(this).find("a").attr("title", tags_object[tag_name]);
      $(this).find("input").val(tag_name);
      
    }
    
  });

  
  //$(".js_prod_main .slick-slide img").each(function(){
  	//$(this).attr('rel', 'fancybox_gallery_1');
  //});
  /*$("body").on("click", ".js_prod_main .slick-slide img", function(e){
    alert('ss');
    $.fancybox({
			//'orig'			: $(this),
			'padding'		: 0,
			'href'			: $(this).attr('src'),
			'title'   		: $(this).attr('alt'),
		});
    alert('2');
  });
  */

});